module.exports = __webpack_public_path__ + "static/media/thumb_down.22c94e1f.svg";